import { onReady } from "./utils/on-ready";
import { LodgingTypes, YesOrNoOptions, TrueOrFalseOptions, NavigationDirections, LifeNeedsDependents, Dependents, FinancialSupportOptions, LifeNeedsSections, Forms, LifeCalculatorSubmissionBooleanProperties, HTMLInputElementIds } from "./models/life-calculator/life-calculator-constants";
import * as ko from 'knockout';
import { LifeCalculatorSubmissionModel } from "./models/life-calculator/life-calculator-submission-model";

export class LifeCalculator {
    public static htmlId = 'life-calculator';

    constructor() {
        onReady(() => {
            this.lifeCalc();
        });
    }

    public logTrackerEvents: boolean = false;

    url_query = (query) => {
        query = query.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var expr = "[\\?&]" + query + "=([^&#]*)";
        var regex = new RegExp(expr);
        var results = regex.exec(window.location.href);
        if (results !== null) {
            return results[1];
        } else {
            return "";
        }
    }

    lifeCalc = () => {
        const track = (action: string): void => {
            try {
                const payload = {
                    hitType: 'pageview',
                    page: `/life-needs-calculator/events/${action}`,
                    title: action
                };
                if (logTrackerEvents)
                    console.log('sending tracker event', payload);
                ga('send', payload);
            } finally {
                // ignore failed tracking, probably an ad blocker.
                return;
            }
        };
        const existingTargetSections = [];
        const amountValidationMessage = "Please enter an amount";
        const numberValidationMessage = "Please enter only numbers.";
        const zipCodeValidationMessage = "Please enter a valid zip code";
        let nextSection = "";
        var viewModel = {
            firstName: ko.observable(""),
            lastName: ko.observable(""),
            zipCode: ko.observable(""),
            email: ko.observable(""),
            dependents: ko.observable(""),
            numberOfChildren: ko.observable(""),
            youngestChildAge: ko.observable(""),
            amountOfIncomeReplaced: ko.observable(""),
            yearsToSupportFamily: ko.observable(""),
            amountToSaveForEducation: ko.observable(""),
            annualIncome: ko.observable(""),
            isHomeowner: ko.observable(""),
            isClient: ko.observable(""),
            monthlyRent: ko.observable(""),
            mortgage: ko.observable(""),
            debt: {
                other: ko.observable("")
            },
            finalExpenses: ko.observable(""),
            currentCoverage: ko.observable("")
        };
        var AgentCode = this.url_query('ac');

        const agentACID = AgentCode === "" ? this.url_query('AgentCode') : AgentCode;
        const sessionId = (document.getElementById('sessionId') as HTMLInputElement).value;
        const submissionId = (document.getElementById('submissionId') as HTMLInputElement).value;

        const model: LifeCalculatorSubmissionModel = new LifeCalculatorSubmissionModel(agentACID, sessionId, submissionId);
        
        ko.applyBindings(viewModel);

        setUpValidation();

        var sectionList = [];
        var choiceList = [];
        var whoDepends: string;
        var financialSupport: string;

        $("section[data-question]").hide();

        $("div section[data-question]:first-child").show();

        $('#success-message').hide();

        $("#getMyReportButton").click(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#resultEmail").focus().offset().top
            }, 1000);
        });

        $('#email-submission').click(function (e) {
            e.preventDefault;
            submitEmail(e);
        });

        $(".mdc-chip[data-choice]").click(function (event) {
            event.preventDefault();
            if (event.target.dataset.choice) {
                changeSelection(event.target);
            }
        });


        $("*[data-navigation]").click(function (event) {
            event.preventDefault();

            const currentSection: JQuery<HTMLElement> = getCurrentSection();

            setNextSectionFromCurrentElementDataSection(event.target.dataset.section, currentSection);

            const navigationAction: string = event.target.dataset.navigation;

            const isNavigationForward = isMatchingValue(NavigationDirections.Forward, navigationAction);
            if (isNavigationForward) {
                validateNextSectionAndNavigateForward(event.target);
            }

            const isNavigationBackward = isMatchingValue(NavigationDirections.Backward, navigationAction);
            if (isNavigationBackward) {
                navigateBackward(event.target.dataset.navigation, currentSection);
            }
        });

        function setNextSectionFromCurrentElementDataSection(targetSection: string, currentSection:JQuery<HTMLElement>): void {
            if (currentSection && currentSection.attr('id') && existingTargetSections[currentSection.attr('id')]) {
                nextSection = existingTargetSections[currentSection.attr('id')];
            }

            if (targetSection) {
                nextSection = targetSection;
            }
        }

        function validateNextSectionAndNavigateForward(targetElement: HTMLElement): void {
            if (isValid(targetElement) && nextSection) {
                navigateForward();
            }
        }

        function navigateBackward(navigationAction: string, currentSection: JQuery<HTMLElement>): void {
            $("section[data-question]").hide();
            $("#" + sectionList.pop()).show();

            // figure out where we are
            if (currentSection) {
                setNextSectionToCurrentSection(currentSection);
            }

            showProgess();
        }

        function setNextSectionToCurrentSection(currentSection: JQuery<HTMLElement>) {
            var selection = choiceList.filter(function (choice) {
                return choice.section === currentSection[0].id;
            });

            if (selection.length > 0) {
                nextSection = selection[0].nextSection;
            }
        }

        $('.ifbi-inline-child').click(function (target) {
            $('.ifbi-inline-child').each(function (i, e) {
                $(this.children[0]).attr('src', '/ResourcePackages/IFBIRedesign/assets/dist/images/child.svg');
            });
            $(this.children[0]).attr('src', '/ResourcePackages/IFBIRedesign/assets/dist/images/child-solid.svg');
            $(this).prevAll('.ifbi-inline-child').children('img').attr('src', '/ResourcePackages/IFBIRedesign/assets/dist/images/child-solid.svg');

            //add this value to model
            model.numberOfChildren = parseInt($(this.children[1]).text().match(/\d+/g)[0]);
            validateChildCount($(target).closest('form').get(0));
        });

        $('.sf_cols').hide();
        $(".sf_cols:nth-child(2)").show();

        function navigateForward() {
            recordProgress();

            var currentSectionId: string = getCurrentSection()[0].id;

            nextSection = getNextSection(currentSectionId);

            resetLifeNeedsAmounts(currentSectionId);

            const nextSectionIsResultsPage = isMatchingValue(LifeNeedsSections.Results, nextSection);
            if (nextSectionIsResultsPage) {
                submitModel();
                $('html, body').animate({ scrollTop: 0 }, 'slow');
                track('Results-Page__view');
            } else {
                moveToNextPage();
            }
        }

        function getNextSection(currentSectionId: string): string {
            if (shouldGoToHomeInfoPage(currentSectionId)) {
                return LifeNeedsSections.HomeInfo;
            }

            if (shouldGoToDebtsPage(currentSectionId)) {
                return LifeNeedsSections.Debts;
            }

            if (shouldGoToChildrensEducationPage(currentSectionId)) {
                return LifeNeedsSections.ChildrensEducation;
            }

            if (shouldGoToAnnualIncomePage(currentSectionId)) {
                return LifeNeedsSections.AnnualIncome;
            }

            return nextSection;
        }

        function shouldGoToHomeInfoPage(currentSectionId: string): boolean {
            const isOnWhoDependsPage = isMatchingValue(LifeNeedsSections.WhoDepends, currentSectionId);
            const isSingle = isMatchingValue(LifeNeedsDependents.JustMe, whoDepends);

            return isOnWhoDependsPage && isSingle;
        }

        function shouldGoToDebtsPage(currentSectionId: string): boolean {
            const isOnHomeInfoPage = isMatchingValue(LifeNeedsSections.HomeInfo, currentSectionId);
            const isSingle = isMatchingValue(LifeNeedsDependents.JustMe, whoDepends);

            return isOnHomeInfoPage && !model.isHomeowner && isSingle;
        }

        function shouldGoToChildrensEducationPage(currentSectionId: string): boolean {
            const isOnFinalExpensesPage = isMatchingValue(LifeNeedsSections.FinalExpenses, currentSectionId);
            const hasChildren = isMatchingValue(LifeNeedsDependents.MeAndMyChildren, whoDepends) || isMatchingValue(LifeNeedsDependents.MeAndMyPartnerAndChildren, whoDepends);

            return isOnFinalExpensesPage && hasChildren;
        }

        function shouldGoToAnnualIncomePage(currentSectionId: string): boolean {
            const selectedBothFinancialSupportOptions = isMatchingValue(FinancialSupportOptions.Both, financialSupport);
            const isOnAmountEducationPage = isMatchingValue(LifeNeedsSections.AmountEducation, currentSectionId);
            const isOnFinalExpensesPage = isMatchingValue(LifeNeedsSections.FinalExpenses, currentSectionId);
            const isOnChildrensEducationPage = isMatchingValue(LifeNeedsSections.ChildrensEducation, currentSectionId);

            return selectedBothFinancialSupportOptions && (isOnAmountEducationPage || isOnFinalExpensesPage || (isOnChildrensEducationPage && !model.isPayingForChildrenEducation));
        }

        function resetLifeNeedsAmounts(sectionId: string): void {
            if (shouldResetIncomeAmounts(sectionId)) {
                resetIncomeAmounts();
            } else if (shouldResetLifeInsuranceAmounts(sectionId)) {
                resetLifeInsuranceAmounts();
            } else if (shouldResetChildrensEducationAmounts(sectionId)) {
                resetChildrensEducationAmounts();
            } else if (shouldResetDebtAmounts(sectionId)) {
                resetDebtAmounts();
            }
        }

        function shouldResetIncomeAmounts(sectionId: string): boolean {
            const isOnWhoDependsPage = isMatchingValue(LifeNeedsSections.WhoDepends, sectionId);
            const isSingle = isMatchingValue(LifeNeedsDependents.JustMe, whoDepends);
            const isOnFinancialSupportPage = isMatchingValue(LifeNeedsSections.FinancialSupport, sectionId);
            const isPayingOffDebt = isMatchingValue(FinancialSupportOptions.Debt, financialSupport);

            return (isOnWhoDependsPage && isSingle) || (isOnFinancialSupportPage && isPayingOffDebt);
        }

        function shouldResetLifeInsuranceAmounts(sectionId: string): boolean {
            const isOnLifeInsurancePage = isMatchingValue(LifeNeedsSections.LifeInsurance, sectionId);

            return isOnLifeInsurancePage && !model.hasLifeInsurance;
        }

        function shouldResetChildrensEducationAmounts(sectionId: string): boolean {
            const isOnChildrensEducationPage = isMatchingValue(LifeNeedsSections.ChildrensEducation, sectionId);

            return isOnChildrensEducationPage && !model.isPayingForChildrenEducation;
        }

        function shouldResetDebtAmounts(sectionId: string): boolean {
            const isOnFinancialSupportPage = isMatchingValue(LifeNeedsSections.FinancialSupport, sectionId);
            const isReplacingIncome = isMatchingValue(FinancialSupportOptions.Income, financialSupport);

            return isOnFinancialSupportPage && isReplacingIncome;
        }

        function resetIncomeAmounts(): void {
            clearHTMLInputValue(HTMLInputElementIds.AnnualIncome);
            clearHTMLInputValue(HTMLInputElementIds.AmountOfIncomeReplaced);
            clearHTMLInputValue(HTMLInputElementIds.YearsToSupportFamily);

            model.annualIncome = 0;
            model.amountOfIncomeReplaced = 0;
            model.yearsToSupportFamily = 0;
        }

        function resetLifeInsuranceAmounts(): void {
            clearHTMLInputValue(HTMLInputElementIds.CurrentCoverage);

            model.currentCoverage = 0;
        }

        function resetChildrensEducationAmounts(): void {
            clearHTMLInputValue(HTMLInputElementIds.ChildEducation);

            model.amountToSaveForEducation = 0;
        }

        function resetDebtAmounts(): void {
            clearHTMLInputValue(HTMLInputElementIds.MonthlyRent);
            clearHTMLInputValue(HTMLInputElementIds.MonthlyMortgage);
            clearHTMLInputValue(HTMLInputElementIds.OutstandingDebt);
            clearHTMLInputValue(HTMLInputElementIds.FinalExpenses);
            clearHTMLInputValue(HTMLInputElementIds.ChildEducation);

            model.monthlyRent = 0;
            model.mortgage = 0;
            model.debt.other = 0;
            model.finalExpenses = 0;
            model.amountToSaveForEducation = 0;
        }

        function clearHTMLInputValue(id: string): void {
            $(`#${id}`).val('');
        }

        //this will update the active button and update the selected value
        function changeSelection(target: HTMLElement): void {
            var chip = $(target).hasClass('mdc-chip') ? $(target) : $(target).parents('.mdc-chip');
            nextSection = chip.hasClass('mdc-chip--selected') ? target.dataset.section : undefined;

            var currentSection: JQuery<HTMLElement> = getCurrentSection();
            let sectionId: string = currentSection[0].id;
            let choice: string = target.dataset.choice;

            updateLifeCalculatorSubmissionModelFromChoice(sectionId, choice);

            existingTargetSections[currentSection.attr('id')] = nextSection;

            updateChoiceList(sectionId, choice, nextSection);

            if (nextSection) {
                validateChipList($(target).closest('form').get(0));
            }
        }

        function updateLifeCalculatorSubmissionModelFromChoice(sectionId: string, choice: string): void {
            const isOnHomeInfoPage = isMatchingValue(LifeNeedsSections.HomeInfo, sectionId);

            const dataChoiceValueName = isOnHomeInfoPage ? LodgingTypes.Own : YesOrNoOptions.Yes;

            const choiceMatchesDataValue = isMatchingValue(dataChoiceValueName, choice);

            const propertyName = getLifeCalculatorSumbissionModelPropertyName(sectionId);

            model[propertyName] = choiceMatchesDataValue;
        }

        function getLifeCalculatorSumbissionModelPropertyName(sectionId: string): string {
            switch (sectionId) {
                case LifeNeedsSections.HomeInfo:
                    return LifeCalculatorSubmissionBooleanProperties.isHomeowner;
                case LifeNeedsSections.CurrentCustomer:
                    return LifeCalculatorSubmissionBooleanProperties.isClient;
                case LifeNeedsSections.LifeInsurance:
                    return LifeCalculatorSubmissionBooleanProperties.hasLifeInsurance;
                case LifeNeedsSections.ChildrensEducation:
                    return LifeCalculatorSubmissionBooleanProperties.isPayingForChildrenEducation;
                default:
                    return '';
            }
        }

        function Choice(section, value, nextSection) {
            this.section = section;
            this.value = value;
            this.nextSection = nextSection;
        }

        function updateChoiceList(section: string, value: string, nextSection: string): void {
            const isOnWhoDependsPage = isMatchingValue(LifeNeedsSections.WhoDepends, section);
            if (isOnWhoDependsPage) {
                whoDepends = value;
            }

            const isOnFinancialSupportPage = isMatchingValue(LifeNeedsSections.FinancialSupport, section);
            if (isOnFinancialSupportPage) {
                financialSupport = value;
            }

            var choice = new Choice(section, value, nextSection);
            var index = -1;
            for (var i = 0; i < choiceList.length; i++) {
                const choiceIsSection = isMatchingValue(choiceList[i].section, section);
                if (choiceIsSection) {
                    index = i;
                }
            }
            if (index >= 0) {
                choiceList.splice(index, 1, choice);
            }
            else {
                choiceList.push(choice);
            }
        }

        function isValid(target: HTMLElement): boolean {
            var form = $(target).closest('form');
            if (form) {
                const isHowManyChildrenForm = isMatchingValue(Forms.HowManyChildrenForm, form.attr('id'));
                if (isHowManyChildrenForm) {
                    return validateChildCount(form.get(0));
                }
                if (form.data('chipList')) {
                    return validateChipList(form.get(0));
                }
                if ((form as any).valid()) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }

        const validateChildCount = (form: any): boolean => {
            var isValid = model.numberOfChildren && model.numberOfChildren > 0;
            const errHolder = $('#child-count-val');
            errHolder.empty();
            if (!isValid) {
                const valMsg = getCustomValidationmessage('Please select the number of children you have.');
                errHolder.append(valMsg);
            }
            return isValid;
        };

        const validateChipList = (form: any): boolean => {
            const hasSelection = existingTargetSections[form.dataset.chipList];
            const errHolder = $(`[data-chip-validation-for='${form.dataset.chipList}']`);
            errHolder.empty();
            if (!hasSelection) {
                const valMsg = getCustomValidationmessage(form.dataset.chipMessage || 'Please make a selection.');
                errHolder.append(valMsg);
                return false;
            }
            return true;
        };

        const getCustomValidationmessage = (message: string): any => {
            const valMsg = $(document.createElement('div'));
            valMsg.addClass('f-t-red');
            valMsg.text(message);
            return valMsg;
        };

        function setUpValidation() {
            ($ as any).validator.addMethod( //doesn't feel right
                "regex",
                function (value, element, regexp) {
                    var re = new RegExp(regexp);
                    return this.optional(element) || re.test(value);
                },
                "Please check your input."
            );

            $('form').each(function (i, e) {
                var id = e.id;
                var settings = formRules(id);
                if (settings) {
                    ($(e) as any).validate({ //doesn't feel right
                        ...settings,
                        errorPlacement: (error, element) => {
                            const fieldName = element.attr('name');
                            const holder = $(`[data-validation-for='${fieldName}']`);
                            if (holder)
                                holder.append(error);
                            else
                                element.append(error);
                        },
                        errorElement: 'span',
                        errorClass: 'f-t-12px f-m-t-8px f-t-red'
                    });
                }
            });



        }

        function formRules(formId) {
            var rules;
            switch (formId) {
                case Forms.NameEmailForm:
                    rules = {
                        rules: {
                            firstName: {
                                required: true,
                                maxlength: 100,
                                regex: /^[a-zA-Z][a-zA-Z-' ]*[a-zA-Z']$/
                            },
                            lastName: {
                                required: true,
                                maxlength: 100,
                                regex: /^[a-zA-Z][a-zA-Z-' ]*[a-zA-Z']$/
                            }
                        },
                        messages: {
                            firstName: {
                                required: "Please enter your first name",
                                maxlength: "Please enter up to 100 characters",
                                regex: "Please only enter letters, hyphens, spaces or apostrophes"
                            },
                            lastName: {
                                required: "Please enter your last name",
                                maxlength: "Please enter up to 100 characters",
                                regex: "Please only enter letters, hyphens, spaces or apostrophes"
                            }

                        }
                    };
                    break;
                case Forms.ZipCodeForm:
                    rules = {
                        rules: {
                            zipCode: {
                                required: true,
                                minlength: 5,
                                maxlength: 10,
                                regex: /(^\d{5}$)|(^\d{5}-\d{4}$)|(^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8}.-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8})/
                            }
                        },
                        messages: {
                            zipCode: {
                                required: zipCodeValidationMessage,
                                minlength: zipCodeValidationMessage,
                                maxlength: zipCodeValidationMessage,
                                regex: zipCodeValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.AmountEducationForm:
                    rules = {
                        rules: {
                            educationAmount: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            educationAmount: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.YearsToSupportFamilyForm:
                    rules = {
                        rules: {
                            amountOfIncomeReplaced: {
                                required: true,
                                number: true
                            },
                            yearsToSupportFamily: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            amountOfIncomeReplaced: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            },
                            yearsToSupportFamily: {
                                required: "Please enter the number of years.",
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.AnnualIncomeForm:
                    rules = {
                        rules: {
                            annualIncome: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            annualIncome: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.RentMonthlyPaymentForm:
                    rules = {
                        rules: {
                            monthlyRent: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            monthlyRent: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.OwnMonthlyPaymentForm:
                    rules = {
                        rules: {
                            monthlyMortgage: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            monthlyMortgage: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.DebtsForm:
                    rules = {
                        rules: {
                            totalDebts: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            totalDebts: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.LifeInsuranceAmountForm:
                    rules = {
                        rules: {
                            insuranceAmount: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            insuranceAmount: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    };
                    break;
                case Forms.CustomReportForm:
                    rules = {
                        rules: {
                            emailaddress: {
                                required: true,
                                regex: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
                            }
                        },
                        messages: {
                            emailaddress: {
                                required: "A valid email address is required",
                                regex: "Please enter a valid email address"
                            }
                        }
                    };
                    break;
                case Forms.FinalExpensesForm:
                    rules = {
                        rules: {
                            finalExpenses: {
                                required: true,
                                number: true
                            }
                        },
                        messages: {
                            finalExpenses: {
                                required: amountValidationMessage,
                                number: numberValidationMessage
                            }
                        }
                    }
                default:
                    break;
            }
            return rules;
        }

        function addNavigationHistory() {
            if (!sectionList.includes($("section[data-question]:visible").attr('id'))) {
                sectionList.push($("section[data-question]:visible").attr('id'));
            }
        }

        function showProgess() {
            var sectionCount = $(document).find('section[data-question]');
            //get current Section
            if (sectionCount) {
                const offset = (1 - calculateProgress(sectionCount)) * 100;
                $('#lifeCalcProgress').find('.ifbi-progress-bar__inner').css('transform', `translateX(-${offset}%)`);
            }
        }

        function calculateProgress(sections) {
            var sectionVisible = $("section[data-question]:visible");
            var index;
            for (var i = 0; i < sections.length; i++) {
                const isVisibleSection = isMatchingValue(sections[i].id, sectionVisible[0].id);
                if (isVisibleSection) {
                    index = i;
                }
            }
            return index / (sections.length - 1);
        }

        function isMatchingValue(valueToMatch: any, currentValue: any): boolean {
            return valueToMatch === currentValue;
        }

        function getCurrentSection(): JQuery<HTMLElement> {
            return $("section[data-question]:visible");
        }

        function submitModel() {
            setDependents();

            $.ajax({
                type: "POST",
                url: "/api/LifeNeeds",
                data: model,
                dataType: "text/javascript",
                complete: data => {
                    var json = JSON.parse(data.responseText);
                    showResult(json.AdditionalNeed);
                    moveToNextPage();
                    launchConfetti();
                }
            });
        }

        function recordProgress() {
            setDependents();
            $.ajax({
                type: "PATCH",
                url: "/api/LifeNeeds",
                data: model,
                dataType: "text/javascript"
            });
        };

        function setDependents() {
            switch (whoDepends) {
                case LifeNeedsDependents.MeAndMyChildren:
                    model.dependents = Dependents.Children;
                    break;
                case LifeNeedsDependents.MeAndMyPartner:
                    model.dependents = Dependents.Partner;
                    break;
                case LifeNeedsDependents.MeAndMyPartnerAndChildren:
                    model.dependents = Dependents.PartnerChildren;
                    break;
                default:
                    model.dependents = Dependents.Solo;
            }
        }

        function showResult(amount) {
            if (amount <= 0) {
                $("#totalNeedText").hide();
                $("#totalNeedHeader").hide();
                $("#totalNeed").html("Congratulations, you appear to have enough life insurance coverage.").removeClass("ifbi-jumbo-header");
            }
            else {
                $("#totalNeedHeader").show();
                $("#totalNeed").html(formatNumberCurrency(amount)).addClass("ifbi-jumbo-header");
                $("#totalNeedText").show();
            }
        }

        function submitEmail(event) {
            if (isValid(event.target)) {
                $.ajax({
                    type: "POST",
                    url: "/api/LifeNeeds",
                    data: model,
                    dataType: "text/javascript",
                    complete: () => $('#success-message').show(),
                    error: () => { }
                });
            }
            recordProgress();
        }


        function moveToNextPage() {
            addNavigationHistory();
            $("section[data-question]").hide();
            $("#" + nextSection).show();
            showProgess();
        }

        function formatNumberCurrency(number) {
            var regex = /(\d)(?=(\d{3})+(?!\d))/g;

            const isDecimal = number % 1 !== 0;
            if (isDecimal) {
                return "$" + number.toFixed(2).toString().replace(regex, '$1,');
            }
            else {
                return "$" + number.toString().replace(regex, '$1,');
            }
        }

        viewModel.firstName.subscribe(function (value) {
            model.firstName = value;
        });

        viewModel.lastName.subscribe(function (value) {
            model.lastName = value;
        });

        viewModel.zipCode.subscribe(function (value) {
            model.zipCode = value;
        });

        viewModel.email.subscribe(function (value) {
            model.email = value;
        });

        viewModel.dependents.subscribe(function (value) {
            model.dependents = value;
        });

        viewModel.youngestChildAge.subscribe(function (value) {
            model.youngestChildAge = parseInt(value);
        });

        viewModel.yearsToSupportFamily.subscribe(function (value) {
            model.yearsToSupportFamily = parseInt(value);
        });

        viewModel.amountOfIncomeReplaced.subscribe(function (value) {
            model.amountOfIncomeReplaced = parseInt(value);
        });

        viewModel.amountToSaveForEducation.subscribe(function (value) {
            model.amountToSaveForEducation = parseInt(value);
        });

        viewModel.annualIncome.subscribe(function (value) {
            model.annualIncome = parseInt(value);
        });

        viewModel.isHomeowner.subscribe(function (value) {
            model.isHomeowner = value.trim() == TrueOrFalseOptions.True ? true : false;
        });

        viewModel.isClient.subscribe(function (value) {
            model.isClient = value.trim() == TrueOrFalseOptions.True ? true : false;
        });

        viewModel.monthlyRent.subscribe(function (value) {
            model.monthlyRent = parseInt(value);
        });

        viewModel.mortgage.subscribe(function (value) {
            model.mortgage = parseInt(value);
        });

        viewModel.debt.other.subscribe(function (value) {
            model.debt.other = parseInt(value);
        });

        viewModel.finalExpenses.subscribe(function (value) {
            model.finalExpenses = parseInt(value);
        });

        viewModel.currentCoverage.subscribe(function (value) {
            model.currentCoverage = parseInt(value);
        });

        viewModel.email.subscribe(function (value) {
            model.email = value;
        });
    };

}